import getPropFromModule from './getPropFromModule';

const getIsFetchingShop = state => {
  const isFetching = getPropFromModule(state, 'isFetching');
  return isFetching;
};

export default getIsFetchingShop;
